import colors from '@STYLES/exports/colors.module.scss';

import extractCSSVars from './helpers/extractCSSVars';

const COLOR = extractCSSVars<string>(colors, (a) => a) as Readonly<Constant.Color>;

export default COLOR;
